module.exports = __webpack_public_path__ + "img/slider.dca17dd6.svg";